import { useEffect, useState } from 'react';
import HfnBlackLogo from '../../assets/images/hfn-black-125.svg';
import { WebHeader } from './WebHeader';
import { MobileHeader } from './MobileHeader';
import { MeProfile } from '../../shared/MySrcm';
import defaultAvatar from '../../assets/images/defaultAvatar.svg';
import { checkImage } from '../../shared/Utils';
import { UserRole } from '../../shared/VolunteerApplicationServiceTypes';
import useUserSession from '../../hooks/useUserSession';

interface AppHeaderProps {
	logout?: () => void;
	mySrcmProfile?: MeProfile | null;
}

export const AppHeader = ({ logout, mySrcmProfile }: AppHeaderProps) => {
	const { selectedRole, allRolesWithModules } = useUserSession();
	const userName = `${mySrcmProfile?.first_name || ''} ${
		mySrcmProfile?.last_name || ''
	}`.trim();
	const profileImage = mySrcmProfile?.photo_url || '';

	const [validImage, setValidImage] = useState(profileImage);

	const showHome =
		selectedRole &&
		[
			UserRole.SNP_ADMIN,
			UserRole.APPROVER,
			UserRole.PREWORK_ADMIN,
			UserRole.SCREENING_ADMIN,
			UserRole.ZC,
			UserRole.NPS_ADMIN,
			UserRole.PROPOSER,
			UserRole.CARE_TEAM,
		].includes(selectedRole);

	const showSwitchRole =
		allRolesWithModules &&
		allRolesWithModules.length > 1 &&
		selectedRole !== UserRole.APPLICANT;

	useEffect(() => {
		const fetchImage = async () => {
			const checkImageValue = await checkImage(profileImage);
			if (profileImage && checkImageValue) {
				setValidImage(profileImage);
			} else {
				setValidImage(defaultAvatar);
			}
		};

		void fetchImage();
	}, [profileImage]);

	return (
		<div className="flex justify-between items-center p-[8px] bg-white">
			<div className="flex items-center">
				<img src={HfnBlackLogo} alt="Header Logo" />
			</div>
			<WebHeader
				logout={logout}
				username={userName}
				profileImage={validImage}
				showHome={showHome || false}
				showSwitchRole={showSwitchRole || false}
			/>
			<MobileHeader
				logout={logout}
				username={userName}
				profileImage={validImage}
				showHome={showHome || false}
				showSwitchRole={showSwitchRole || false}
			/>
		</div>
	);
};
